<template>
  <div id="main">
    <div class="float-button">
      <div class="button2">
        <button class="btn btn-default btn_option button1" v-print="'#outerDiv'">打印</button>
      </div>
      <!--<div class="button2">
        <button class="btn btn-default btn_option button1" @click="exportPage()">导出</button>
      </div>-->
    </div>
    <div id="outerDiv" class="outerDiv">
      <div class="class_head_title_self">
        <div class="head_title_font class_head_title_font">开班信息</div>
      </div>
      <div class="class_body_content_self">
        <table class="table table-striped table-bordered printTable">
          <tbody>
          <tr>
            <th>班级名称</th>
            <th>开课时间</th>
            <th>结业时间</th>
            <th>班级类型</th>
          </tr>
          <tr>
            <td>{{classInfo.name}}</td>
            <td>{{classInfo.startDate}}</td>
            <td>{{classInfo.endDate}}</td>
            <td>{{classInfo.type |formatType}}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="class_head_title_self">
        <div class="head_title_font class_head_title_font">班主任</div>
      </div>
      <div class="class_body_content_self">
        <table class="table table-striped table-bordered printTable">
          <tbody>
          <tr>
            <th>人员姓名</th>
            <th>角色</th>
            <!--<th>所属部门</th>-->
            <th>联系电话</th>
            <th>邮箱</th>
            <th>办公地点</th>
          </tr>
          <tr v-for="(teacherClazzInfo, index) in teacherClazzInfoList" :key="index">
            <td>{{teacherClazzInfo.teacherName}}</td>
            <td> {{teacherClazzInfo.type}}</td>
            <!--<td>{{teacherClazzInfo.dept}}</td>-->
            <td>{{teacherClazzInfo.tel}}</td>
            <td>{{teacherClazzInfo.mail}}</td>
            <td>{{teacherClazzInfo.office}}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="class_head_title_self">
        <div class="head_title_font class_head_title_font">食宿安排</div>
      </div>
      <div class="class_body_content_self">
        <table class="table table-striped table-bordered printTable">
          <tbody>
          <tr>
            <th>宿舍安排</th>
            <th>宿舍入住时间</th>
            <th>就餐安排</th>
            <th width="50%">备注</th>
          </tr>
          <tr>
            <td>{{hotel.name}}</td>
            <td>{{hotel.time}}</td>
            <td>
              <div v-for="(can, index) in canteen" :key="index">
                {{can.canteen}} {{can.startTime}} —— {{can.endTime}}
              </div>
            </td>
            <td width="50%">{{classInfo.ssSummary}}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="class_head_title_self">
        <div class="head_title_font class_head_title_font">学员名单</div>
      </div>
      <div class="class_body_content_self">
        <table class="table table-striped table-bordered printTable">
          <tbody>
          <tr>
            <th class="tablexuhao">序号</th>
            <th>姓名</th>
            <th>性别</th>
            <th>民族</th>
            <th>出生日期</th>
            <th>政治面貌</th>
            <th>工作单位及职务</th>
            <!--<th>职务</th>-->
            <th>联系电话</th>
          </tr>
          <tr v-for="(studentt,index) in studentList" :key="index">
            <td>{{index+1}}</td>
            <td>{{studentt.name}}</td>
            <td>{{studentt.sex | formatSex}}</td>
            <td>{{studentt.nation}}</td>
            <td>{{studentt.birthday}}</td>
            <td>{{studentt.policitalStatus}}</td>
            <td>{{studentt.department}}</td>
           <!-- <td>{{studentt.duty}}</td>-->
            <td>{{studentt.tel}}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="class_head_title_self">
        <div class="head_title_font class_head_title_font">培训日程</div>
      </div>
      <div class="unit_one" v-for="(training, index) in trainingScheduleList" :key="index">
        <div class="unit_one_content_header_div">
          <strong style="margin-bottom: 10px">{{training.name}}</strong>
          <p>起止日期：{{training.startDate}} —— {{training.endDate}}</p>
          <p>单元内容：{{training.content}}</p>
        </div>
        <table class="table table-striped table-bordered trainingScheduletable">
          <thead>
          <tr>
            <th>序号</th>
            <th>日期</th>
            <th>时间</th>
            <th>教学内容</th>
            <th>主讲老师</th>
            <th>上课地点</th>
            <!--<th>关联问卷</th>-->
          </tr>
          </thead>
          <tbody>
          <tr v-for="(less, index_less) in training.lessons" :key="index_less">
            <td>{{index_less+1}}</td>
            <td>{{less.startDate}}</td>
            <td>{{less.time}}</td>
            <td>{{less.name}}</td>
            <td>{{less.teacherName}}</td>
            <td>{{less.roomName}}</td>
            <!--<td>{{less.questionnaireContent}}</td>-->
          </tr>
          </tbody>
        </table>
      </div>

      <div class="class_head_title_self">
        <div class="head_title_font class_head_title_font">作业安排</div>
      </div>
      <div class="class_body_content_self">
        <table class="table table-striped table-bordered homeTable">
          <thead>
          <tr>
            <th>{{schoolWorkType[0]}}</th>
            <th>作业要求</th>
            <th>提交截止时间</th>
            <th>附件</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(school, index) in schoolWorkList" :key="index" v-if="school.type == schoolWorkType[0]">
            <td>{{school.name}}</td>
            <td>{{school.summary}}</td>
            <td>{{school.deadline}}</td>
            <td>{{school.fileName}}</td>
          </tr>
          </tbody>
        </table>
        <table class="table table-striped table-bordered homeTable">
          <tbody>
          <tr>
            <th>{{schoolWorkType[1]}}</th>
            <th>作业要求</th>
            <th>提交截止时间</th>
            <th>附件</th>
          </tr>
          <tr v-for="(school, index) in schoolWorkList" :key="index" v-if="school.type == schoolWorkType[1]">
            <td>{{school.name}}</td>
            <td>{{school.summary}}</td>
            <td>{{school.deadline}}</td>
            <td>{{school.fileName}}</td>
          </tr>
          </tbody>
        </table>
        <table class="table table-striped table-bordered homeTable">
          <thead>
          <tr>
            <th>{{schoolWorkType[2]}}</th>
            <th>作业要求</th>
            <th>提交截止时间</th>
            <th>附件</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(school, index) in schoolWorkList" :key="index" v-if="school.type == schoolWorkType[2]">
            <td>{{school.name}}</td>
            <td>{{school.summary}}</td>
            <td>{{school.deadline}}</td>
            <td>{{school.fileName}}</td>
          </tr>
          </tbody>
        </table>
        <table class="table table-striped table-bordered homeTable">
          <thead>
          <tr>
            <th>{{schoolWorkType[3]}}</th>
            <th>作业要求</th>
            <th>提交截止时间</th>
            <th>附件</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(school, index) in schoolWorkList" :key="index" v-if="school.type == schoolWorkType[3]">
            <td>{{school.name}}</td>
            <td>{{school.summary}}</td>
            <td>{{school.deadline}}</td>
            <td>{{school.fileName}}</td>
          </tr>
          </tbody>
        </table>
        <!--<table class="table table-striped table-bordered">
          <tbody>
          <tr>
            <th>{{schoolWorkType[4]}}</th>
            <th>作业要求</th>
            <th>提交截止时间</th>
            <th>附件</th>
          </tr>
          <tr v-for="(school, index) in schoolWorkList" :key="index" v-if="school.type == schoolWorkType[4]">
            <td>{{school.name}}</td>
            <td>{{school.summary}}</td>
            <td>{{school.deadline}}</td>
            <td>{{school.fileName}}</td>
          </tr>
          </tbody>
        </table>-->
      </div>

<!--      <div class="class_head_title_self">-->
<!--        <div class="head_title_font class_head_title_font">作业成绩</div>-->
<!--      </div>-->
<!--      <div class="class_body_content_self">-->
<!--        <table class="table table-striped table-bordered printTable">-->
<!--          <thead>-->
<!--          <tr>-->
<!--            <th width="10%">序号</th>-->
<!--            <th width="40%">学员姓名</th>-->
<!--            <th width="50%">平均分</th>-->
            <!-- <th>优</th>
             <th>良</th>
             <th>及格</th>
             <th>不及格</th>-->
            <!--<th>详情</th>-->
<!--          </tr>-->
<!--          </thead>-->
<!--          <tbody>-->
<!--          <tr v-for="(studentWorkResultOne,index) in allStudentWorkResultList" :key="index">-->
<!--            <td width="10%">{{index+1}}</td>-->
<!--            <td width="40%">{{studentWorkResultOne.studentName}}</td>-->
<!--            <td width="50%">{{studentWorkResultOne.avgScore}}</td>-->
            <!--  <td width="20%">{{studentWorkResultOne.optimal}}</td>
              <td width="20%">{{studentWorkResultOne.good}}</td>
              <td width="20%">{{studentWorkResultOne.passed}}</td>
              <td width="20%">{{studentWorkResultOne.unPassed}}</td>-->
            <!--<td>-->
            <!--<div class="details_pic" data-toggle="modal" data-target="#myModal" @click="studentScoreAndRemarkData(studentWorkResultOne.studentId)" ></div>-->
            <!--</td>-->
<!--          </tr>-->
<!--          </tbody>-->
<!--        </table>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from "../main";
  import {getContentSize} from './mainView';
  import dictionaryData from '../json/dictionary';

  import Vue from 'vue';
  import htmlToPdf from '../utils/htmlToPdf';
  Vue.use(htmlToPdf);

  export default {
    name: "printPreview",
    data() {
      return {
        clazzId: this.$store.state.clazzId,
        publishStatus: this.$store.state.publishStatus,
        classStatus: this.$store.state.classStatus,

        classInfo: {},

        //班主任
        teacherClazzInfoList: [],

        //食宿安排
        hotel: {
          name: "",
          time: ""
        },
        canteen: [
          {canteen:"",startTime:"",endTime:""},
          {canteen:"",startTime:"",endTime:""},
          {canteen:"",startTime:"",endTime:""}
        ],

        //学生名单
        studentList: [],

        //培训日程
        trainingScheduleList: [],

        //作业安排
        schoolWorkList: [],
        //作业类型
        schoolWorkType: [
          // '心得体会',
          '党性修养考核',
          '知识能力考核',
          '调研课题',
          '结业论文'
        ],

        //作业成绩
        allStudentWorkResultList:[]
      }
    },
    filters: {
      formatSex(value){
        let this_ = this;
        if(dictionaryData.sex && value){
          value = dictionaryData.sex[value];
        }
        return value;
      },
      formatType(value){
        let this_ = this;
        if(dictionaryData.clazz_type && value){
          value = dictionaryData.clazz_type[value];
        }
        return value;
      }
    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();

        this_.initPrintPreviewData();
      });
    },
    methods: {
      /**
       * 初始加载
       */
      initPrintPreviewData(){
        let this_=this;
        if(this_.clazzId){
          schoolAxios({
            method: 'get',
            url: 'clazz/load/'+this_.clazzId,
            params:{}
          }).then(function (response) {
            let data = response.data;
            if(data.success){
              this_.classInfo = data.data;
              if(data.data.hotel){
                this_.hotel = JSON.parse(data.data.hotel);
              }
              if(data.data.canteen){
                this_.canteen = JSON.parse(data.data.canteen);
              }
            }
          });
          schoolAxios({
            method:'get',
            url: 'teacherClazz/findTeacherClazz',
            params:{
              'clazzId':this_.clazzId
            }
          }).then(function (response) {
            let data=response.data;
            if(data.success){
              this_.teacherClazzInfoList=data.list;
            }
          });
          schoolAxios({
            method: 'get',
            url: 'student/findList',
            params: {
              clazzId: this_.clazzId
            }
          }).then(function (resp) {
            // console.info(resp);
            this_.studentList = resp.data.list;
          });
          schoolAxios({
            method: 'get',
            url: 'unit/findDetailsListBy',
            params: {
              'clazzId': this_.clazzId,
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              this_.trainingScheduleList = data.list;
            }
          });
          schoolAxios({
            method: 'get',
            url: 'schoolwork/findSchoolHomeworkList',
            params:{
              "clazzId":this_.clazzId,
            }
          }).then(function (response) {
            let data = response.data;
            if(data.success){
              this_.schoolWorkList = data.list;
            }
          });
          schoolAxios({
            method: 'get',
            url: 'studentSchoolwork/studentsWorkResultList',
            params:{
              "clazzId":this_.clazzId,
            }
          }).then(function (response) {
            let data = response.data;
            if(data.success){
              this_.allStudentWorkResultList=data.list;
            }
          });
        }
      },
      /**
       * 打印
       */
      printPage(){
        let this_ = this;
        $.print("#outerDiv");
      },
      /**
       * 导出
       */
      exportPage(){
        let this_ = this;
        "确定导出PDF文件".showConfirm(function () {
          this_.getPdf(this_.classInfo.name);
        });
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  @import "../assets/css/printPreview.css";
</style>



// WEBPACK FOOTER //
// src/components/printPreview.vue